export default __webpack_public_path__ + "static/media/cwu18.34147c3d.jpeg";